import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";


@Component({
    selector: 'app-lion-email-reply-popup',
    templateUrl: './email-reply.component.html',
    styleUrls: ['./email-reply.component.scss']
})

export class EmailReplyPopupComponent implements OnInit, OnChanges {
    
    @Input() emailReplyData: any;
    @Input() displayEmailReplyPopup: boolean;

    @Output() cancelEmailReplyPopup = new EventEmitter<any>();
    displayFilePreview: boolean;
    currentFile: any;
 
    ngOnInit(): void {
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.emailReplyData && changes?.emailReplyData?.currentValue){
            this.emailReplyData = changes?.emailReplyData?.currentValue;
        }
    }

    closeEmailReplyPopup(): void {
        this.displayEmailReplyPopup = false;
        this.cancelEmailReplyPopup.emit();
    }

    openFilePreview(file: any): void {
        this.displayFilePreview = true;
        this.currentFile = file;
    }

    closeFilePreview() {
        this.displayFilePreview = false;
    }
}